import { Box, Typography, Modal, IconButton, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import type { ReactNode } from 'react'

interface FileModalProps {
  open: boolean
  onClose: () => void
  fileName: string
  children: ReactNode
}

export const FileModal = ({ open, onClose, fileName, children }: FileModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Box
        sx={{
          width: '95vw',
          height: '100vh',
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 1,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6" sx={{ flex: 1, mr: 2 }}>
            {fileName}
          </Typography>
          <Stack direction="row" spacing={1}>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        <Box sx={{ flex: 1, overflow: 'hidden' }}>{children}</Box>
      </Box>
    </Modal>
  )
}
